<template>
  <div>
    <headerNav title="领券活动" />
     <van-cell-group>
      <van-cell title="" value="查看我已领取的优惠券" to="/user/coupon/list" is-link />
    </van-cell-group>
    <ul>
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <li
          v-for="(item, index) in list"
          :key="index"
          :class="'couponitem ' + (item.show ? 'show' : '')"
        >
          <div class="couponTop">
            <div class="cpnamount">
              <div class="amountWrap">
                <div class="amount">
                  <span class="amountSign"> ￥</span>
                  <span class="amountNum">{{ item.price }}</span>
                </div>
                <div class="condition">
                  <span>{{
                    item.minSellPrice > 0 ? "满" + item.minSellPrice + "元可用" : "无门槛"
                  }}</span>
                </div>
              </div>
            </div>
            <div class="couponInfoWrap">
              <div class="cpninfo">
                <div class="detail">
                  <span class="name">{{ item.couponTypeName }}</span>
                </div>
              </div>
              <div class="validity">
                <span>活动截止：{{ item.endTime }} </span>
              </div>
              <van-button type="danger" size="small" v-if="item.isRev" @click="rev(item)"
                >立即领取</van-button
              >
              <div style="float:right;margin:5px" v-else>您已达到领取上限</div>
            </div>
          </div>
          <div class="couponMid">
            <span>详细信息</span>
            <van-icon name="arrow" class="down" @click="showinfo(index)" />
          </div>
          <div class="info">
            <div class="text" v-if="item.couponType == 1">
              可参与品类：
              <div
                v-for="(cate, index2) in item.couponActiveCateDetails"
                :key="index2"
                style="margin: 5px"
              >
                <van-tag type="primary"> {{ cate.cate.cateName }}</van-tag>
              </div>
            </div>
            <div class="text" v-if="item.couponType == 2">
              可参与商品：
              <div
                v-for="(prod, index2) in item.couponActiveProductDetails"
                :key="index2"
                style="margin: 5px"
              >
                <van-tag type="primary"> {{ prod.product.pName }}</van-tag>
              </div>
            </div>
          </div>
        </li>
      </van-list>
    </ul>
  </div>
</template>

<script>
import { GetCoupon, ExchangeCoupon } from "../../../api/user.js";

export default {
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      params:{
          ids:[]
      }
    };
  },
  computed: {},
  created(){
     let ids= localStorage.getItem('couponids')
     if(ids){
         this.params.ids=ids.split(',');
     }
     localStorage.removeItem('couponids')
      console.log()
  },
  methods: {
    onLoad() {
      this.ajax
        .post("/api/services/app/PhoneCouponActive/QueryAvailableModelList",this.params)
        .then((x) => {
          this.list = x.result;
          this.loading = false;
          this.finished = true;
        });
    },
    showinfo(index) {
      this.$set(this.list[index], "show", !this.list[index].show);
    },
    rev(item) {
      this.ajax
        .post("/api/services/app/PhoneCouponActive/RevCoupon?id=" + item.id)
        .then((x) => {
          this.$toast.success("领取成功");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.couponitem {
  padding: 0 10px;
  margin-top: 10px;
  position: relative;
  font-size: 12px;
  .couponTop {
    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px dashed #f3d4d4;
    border-radius: 8px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .cpnamount {
      position: relative;
      height: 90px;
      width: 34.08%;
      text-align: center;
      float: left;
      border-right: 1px dashed #f3d4d4;
    }
    .amountWrap {
      width: 100%;
      position: absolute;
      top: 50%;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      .amount {
        font-size: 15px;
        .amountSign {
          margin-right: 3px;
        }
        .amountNum {
          font-size: 39px;
          line-height: 1;
          font-weight: bold;
        }
      }
    }
  }
  .couponInfoWrap {
    position: relative;
    margin-left: 37.465%;
    height: 80px;
    .cpninfo {
      position: absolute;
      top: 26px;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      width: 100%;
      .detail {
        padding-right: 15px;
        word-break: break-all;
        .name {
          font-size: 13px;
          color: #000;
        }
      }
    }
    .validity {
      position: absolute;
      bottom: 16px;
      font-size: 12px;
    }
    button {
      right: 16px;
      position: absolute;
      bottom: 40px;
    }
  }
  .couponMid {
    position: relative;
    height: 31px;
    line-height: 31px;
    padding-left: 16px;
    font-size: 12px;

    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px solid #f3d4d4;
    border-radius: 8px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    i {
      right: 16px;
      position: absolute;
      top: 8px;
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }
    span {
      position: relative;
      left: -105px;
    }
  }

  .info {
    display: none;
    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px solid #f3d4d4;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 10px 25px 12px 15px;
    font-size: 12px;
  }
}
.show {
  .couponMid {
    border-bottom: 1px dashed #f3d4d4;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    i {
      -webkit-transform: rotate(-90deg);
      transform: rotate(-90deg);
    }
  }
  .info {
    display: block;
  }
}
.gray {
  -webkit-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
}
</style>
